var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 18.3327C14.5998 18.3327 18.3307 14.6017 18.3307 9.99935C18.3307 8.61766 17.9945 7.31451 17.3993 6.16727C17.2747 5.92697 16.954 5.88788 16.7626 6.0793L10.3426 12.4993C9.6917 13.1502 8.63643 13.1502 7.98555 12.4993L5.65814 10.1719C5.3327 9.8465 5.3327 9.31886 5.65814 8.99343C5.98358 8.66799 6.51121 8.66799 6.83665 8.99343L9.16406 11.3208L15.8485 4.64107C16.0066 4.48313 16.0127 4.2278 15.8537 4.07077C14.3486 2.58392 12.2802 1.66602 9.9974 1.66602C5.39502 1.66602 1.66406 5.39698 1.66406 9.99935C1.66406 14.6017 5.39502 18.3327 9.9974 18.3327Z",
    fill: "#45DC11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4223625ad697af86f689685a2f206829.svg";
export { ForwardRef as ReactComponent };